import { MatchResultModel } from './MatchResultModel';
import { MatchDayModel, emptyMatchDayModel } from './MatchDayModel';

export interface MatchDayResultsModel {
  matchDay: MatchDayModel;
  results: MatchResultModel[];
}

export const emptyMatchDayResultsModel: MatchDayResultsModel = {
  matchDay: emptyMatchDayModel,
  results: [],
};
